/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateIndexRequest = {
  /**
   * The name of the index
   */
  indexName: string;
};

/** @internal */
export const CreateIndexRequest$inboundSchema: z.ZodType<
  CreateIndexRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  index_name: z.string(),
}).transform((v) => {
  return remap$(v, {
    "index_name": "indexName",
  });
});

/** @internal */
export type CreateIndexRequest$Outbound = {
  index_name: string;
};

/** @internal */
export const CreateIndexRequest$outboundSchema: z.ZodType<
  CreateIndexRequest$Outbound,
  z.ZodTypeDef,
  CreateIndexRequest
> = z.object({
  indexName: z.string(),
}).transform((v) => {
  return remap$(v, {
    indexName: "index_name",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace CreateIndexRequest$ {
  /** @deprecated use `CreateIndexRequest$inboundSchema` instead. */
  export const inboundSchema = CreateIndexRequest$inboundSchema;
  /** @deprecated use `CreateIndexRequest$outboundSchema` instead. */
  export const outboundSchema = CreateIndexRequest$outboundSchema;
  /** @deprecated use `CreateIndexRequest$Outbound` instead. */
  export type Outbound = CreateIndexRequest$Outbound;
}

export function createIndexRequestToJSON(
  createIndexRequest: CreateIndexRequest,
): string {
  return JSON.stringify(
    CreateIndexRequest$outboundSchema.parse(createIndexRequest),
  );
}

export function createIndexRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateIndexRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateIndexRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateIndexRequest' from JSON`,
  );
}
